import React from "react";
import { Link } from "react-router-dom";
import CookieConsentComponent from "../../legal/CookieConsentComponent";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import {useTranslation} from 'react-i18next';

const AboutUs = () => {
  const { t } = useTranslation();

  const isDarkMode = useSelector(
      (state: RootState) => state.darkMode.isDarkMode
  );

  const language = useSelector((state: RootState) => state.language.language);

  return (
      <div className="w-full px-4 md:px-12 py-6 text-xs text-gray-500 dark:text-neutral-500 font-medium">
        <div className="max-w-6xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-center md:text-left md:mb-0 mb-16">
          <div>
            Copyright © 2026 MoonSkins.GG All rights reserved. MoonSkins is a brand of Brink Engineering UG.
          </div>
          <div className="flex flex-wrap justify-center md:justify-end items-center gap-x-4 gap-y-2">
            <Link to="/tos" className="hover:underline">{t("footer.tos")}</Link>
            <Link to="/privacy-policy" className="hover:underline">{t("footer.privacyPolicy")}</Link>
            <Link to="/refund-policy" className="hover:underline">{t("footer.refundPolicy")}</Link>
            <Link to="/imprint" className="hover:underline">{t("footer.imprint")}</Link>
            <div className="flex items-center gap-2">
              <Link to="/cookies" className="hover:underline">{t("footer.cookies")}</Link>
              <CookieConsentComponent language={language} isDarkMode={isDarkMode} />
            </div>
          </div>
        </div>
      </div>
  );
};

export default AboutUs;